<template>
  <div class="employ-wrap">
    <div class="select-post">
      <div class="title">Job Applied (maximum of three options):</div>
      <div class="content">{{checkedPositionText}}</div>
    </div>
    <div class="select-box-wrap">
      <!-- <div class="title">【学科教师】<span class="sub-title">就业地点：合肥</span></div> -->
      <div class="content">
        <el-checkbox-group :max="3" v-model="checkedPosition">
          <!-- <div class="primary-wrap">
            <span class="desc">小学</span>
              <el-checkbox
                :id="index === 0 ? 'primary01' : ''"
                v-for="(p, index) in primary"
                :key="p.value"
                :label="p.value">{{p.label}}</el-checkbox>
          </div>
          <div class="middle-wrap">
            <span class="desc">初中</span>
              <el-checkbox
                v-for="m in middle"
                :key="m.value"
                :label="m.value">{{m.label}}</el-checkbox>
          </div>
          <div class="high-wrap">
            <span class="desc">高中</span>
              <el-checkbox
                v-for="h in high"
                :key="h.value"
                :label="h.value">{{h.label}}</el-checkbox>
          </div>
          <div class="coach-wrap" v-if="false">
            <div class="title">【竞赛计划】<span class="sub-title">就业地点：合肥</span></div>
            <div class="content">
              <div class="middle-wrap">
                <span class="desc">初中</span>
                <el-checkbox
                    v-for="sub in middleCoach"
                    :label="sub.value"
                    :key="sub.value">{{sub.label}}</el-checkbox>
              </div>
              <div class="high-wrap">
                <span class="desc">高中</span>
                <el-checkbox
                    v-for="sub in highCoach"
                    :label="sub.value"
                    :key="sub.value">{{sub.label}}</el-checkbox>
              </div>
            </div>
          </div>
          <div class="manage-train-wrap">
            <div class="title">【管理培训生】<span class="sub-title">就业地点：合肥</span></div>
            <div class="content">
              <div class="primary-wrap">
                <span class="desc">小学</span>
                <el-checkbox
                    v-for="sub in primaryManageTrain"
                    :label="sub.value"
                    :key="sub.value">{{sub.label}}</el-checkbox>
              </div>
              <div class="middle-wrap">
                <span class="desc">初中</span>
                <el-checkbox
                    v-for="sub in middleManageTrain"
                    :label="sub.value"
                    :key="sub.value">{{sub.label}}</el-checkbox>
              </div>
            </div>
          </div>
          <div class="backbone-campus-wrap">
            <div class="title">【新分校骨干】<span class="sub-title">就业地点：南京、芜湖、马鞍山、安庆、滁州</span></div>
            <div class="content">
              <div class="primary-wrap">
                <span class="desc">小学</span>
                <el-checkbox
                    v-for="sub in primaryBackboneCampus"
                    :label="sub.value"
                    :key="sub.value">{{sub.label}}</el-checkbox>
              </div>
              <div class="middle-wrap">
                <span class="desc">初中</span>
                <el-checkbox
                    v-for="sub in middleBackboneCampus"
                    :label="sub.value"
                    :key="sub.value">{{sub.label}}</el-checkbox>
              </div>
            </div>
          </div> -->
          <div class="checkdiv" v-for="p in washs" :key="p.value">
            <el-checkbox
            :value="p.value"
            :label="p.value">
            <!--<span class="title">{{ p.label }}</span>-->
            <span class="sub-title">{{ p.value }}</span>
           </el-checkbox>
          </div>
        </el-checkbox-group>
      </div>
    </div>
    <!-- <div class="assign-wrap">
      <div class="title">科目是否服从分配</div>
      <div class="content">
        <el-radio-group v-model="subjectAssignRadio">
          <el-radio :label="1">是</el-radio>
          <el-radio :label="2">否</el-radio>
        </el-radio-group>
      </div>
    </div> -->
<!--    <div class="want-place">-->
<!--      <div class="title">期望就业地点（按意愿排序最多三项）:</div>-->
<!--      <div class="content">{{checkedEmployPlaceText}}</div>-->
<!--    </div>-->
<!--    <div class="want-place-box">-->
<!--      <el-checkbox-group :max="3" v-model="checkedEmployPlace">-->
<!--        <el-checkbox-->
<!--          :id="index===1?'place01':''"-->
<!--          v-for="(place, index) in employPlaces"-->
<!--          :key="place"-->
<!--          :label="place">{{place}}</el-checkbox>-->
<!--      </el-checkbox-group>-->
<!--    </div>-->
    <div class="assign-wrap">
      <div class="title">Willing to reallocate ?</div>
      <div class="content">
        <el-radio-group v-model="assignRadio">
          <el-radio :label="1">Yes</el-radio>
          <el-radio :label="2">No</el-radio>
        </el-radio-group>
      </div>
    </div>
    <div class="select-standard-wrap">
      <div class="title">Career Path Expectation criteria (based on importance, select up to 3 items):</div>
      <div class="content">{{selectStandardsText}}</div>
    </div>
    <div class="select-standard-box">
      <div
        :class="[selectStandard.includes(s) ? 'active': '']"
        @click="handleSelectStandard(s)"
        v-for="s in selectStandards"
        :key="s.id"
        class="standard-item">{{s.text}}</div>
    </div>
  </div>
</template>

<script>
const employs = {
  primary: [{label: '小学数学', value: '1：小学数学', text: '学科教师-小学数学'}],
  middle:[{
    label: '初中数学',
    value: '1：初中数学',
    text: '学科教师-初中数学'
  }, {
    label: '初中物理',
    value: '1：初中物理',
    text: '学科教师-初中物理'
  },{
    label: '初中化学',
    value: '1：初中化学',
    text: '学科教师-初中化学'
  }],
  high: [{
    label: '高中数学',
    value: '1：高中数学',
    text: '学科教师-高中数学'
  }, {
    label: '高中物理',
    value: '1：高中物理',
    text: '学科教师-高中物理'
  }, {
    label: '高中化学',
    value: '1：高中化学',
    text: '学科教师-高中化学'
  }],
  washs: [
    { label: '', value: 'Mathematics Teacher', text: '' },
    { label: '', value: 'Learning Consultant', text: '' },
    { label: '', value: 'Personal Assistant Cum Driver', text: '' }
  ]
}
const coach = {
  middle: [
    {label: '初中数学竞赛教练',value: '2：初中数学竞赛教练'},
    {label: '初中物理竞赛教练', value: '2：初中物理竞赛教练'},
    {label: '初中化学竞赛教练', value: '2：初中化学竞赛教练'},
    {label: '初中信息学竞赛教练', value: '2：初中信息学竞赛教练'}
  ],
  high: [
    {label: '高中数学竞赛教练', value: '2：高中数学竞赛教练'},
    {label: '高中物理竞赛教练', value: '2：高中物理竞赛教练'},
    {label: '高中化学竞赛教练', value: '2：高中化学竞赛教练'},
    {label: '高中信息学竞赛教练', value: '2：高中信息学竞赛教练'},
  ]
}
//const coachSubjects = ['数学竞赛教练', '物理竞赛教练', '化学竞赛教练', '信息学竞赛教练']
const manageTrains = {
  primary: [
    {label: '小学数学', value: '3：小学数学', text: '管理培训生-小学数学'},
    {label: '小学英语', value: '3：小学英语', text: '管理培训生-小学英语'}
  ],
  middle: [
    {label: '初中数学', value: '3：初中数学', text: '管理培训生-初中数学'},
    {label: '初中物理', value: '3：初中物理', text: '管理培训生-初中物理'},
    {label: '初中化学', value: '3：初中化学', text: '管理培训生-初中化学'},
    {label: '初中英语', value: '3：初中英语', text: '管理培训生-初中英语'},
  ]
}
const backbone = {
  primary: [
    {label: '小学数学', value: '4：小学数学', text: '新分校骨干-小学数学'}
  ],
  middle: [
    {label: '初中数学', value: '4：初中数学', text: '新分校骨干-初中数学'}
  ]
}
const employPlaces = ['安徽合肥', '安徽芜湖', '安徽安庆', '安徽马鞍山', '江苏南京']
const selectStandards = [
  {id: '01', text: 'Leadership', active: false},
  {id: '02', text: 'Compensation and Benefits', active: false},
  {id: '03', text: 'Career Development Prospects', active: false},
  {id: '04', text: 'Office environment', active: false},
  {id: '05', text: 'location', active: false},
  {id: '08', text: 'Company size', active: false},
  {id: '09', text: 'Company culture', active: false}
]
export default {
  data: () => ({
    checkedPosition: [],
    checkedCoachSubject: [],
    checkedEmployPlace: [],
    subjectAssignRadio: 1,
    assignRadio: 1,
    minIncome: '',
    maxIncome: '',
    primary: employs['primary'],
    middle: employs['middle'],
    high: employs['high'],
    washs: employs['washs'],
    middleCoach: coach['middle'],
    highCoach: coach['high'],
    primaryManageTrain: manageTrains['primary'],
    middleManageTrain: manageTrains['middle'],
    primaryBackboneCampus: backbone['primary'],
    middleBackboneCampus: backbone['middle'],
    //coachSubjects,
    employPlaces,
    selectStandards,
    isChecked: false,
    fileList: [],
    selectStandard: [],
    fileFormDataArr: [],
    fileNames: []
  }),
  computed: {
    checkedPositionText() {
      if (!this.checkedPosition.length) {
        return ''
      } else {
        const positionArr = this.checkedPosition.map((item, index) => {
          const index_text = index === 0 ? 'First Choice：' : index === 1 ? 'Second Choice：' : 'Third Choice：'
          // if (item.indexOf('1') > -1) {
          //   item = item.replace('1：', '学科教师-')
          // } else if (item.indexOf('2') > -1) {
          //   item = item.replace('2：', '')
          // } else if (item.indexOf('3') > -1) {
          //   item = item.replace('3：', '管理培训生-')
          // } else if (item.indexOf('4') > -1) {
          //   item = item.replace('4：', '新分校骨干-')
          // }
          item = `${index_text}${item}`
          return item
        })
        const text = positionArr.join('、')
        return text
      }
    },
    checkedEmployPlaceText() {
      if (!this.checkedEmployPlace.length) {
        return ''
      } else {
        const placeArr = this.checkedEmployPlace.map((it, index) => {
          const index_text = index === 0 ? 'First Choice：' : index === 1 ? 'Second Choice：' : 'Third Choice：'
          it = `${index_text}${it}；`
          return it
        })
        return placeArr.join(' ')
      }
    },
    selectStandardsText() {
      if (!this.selectStandard.length) {
        return ''
      }
      let textArr = this.selectStandard.map(a => a.text)
      textArr = textArr.map((it, index) => {
        const index_text = index === 0 ? '①' : index === 1 ? '②' : index === 2 ? '③' : ''
        return `${index_text}${it}；`
      })
      return textArr.join(' ')
    }
  },
  methods: {
    handleFileChange() {
      this.fileNames = []
      this.fileFormDataArr = []
      let files = this.$refs.uploadBtn.files
      for (let i = 0; i < files.length; i++) {
        if (files[i].size > 2097152) {
          this.$message.error(`${files[i].name}MAX 2M`)
        } else {
          this.fileNames.push(files[i].name)
          this.fileFormDataArr.push(files[i])
        }
      }
    },
    handleSelectStandard(it) {
      if (this.selectStandard.includes(it)) {
        const index = this.selectStandard.findIndex(t => t === it)
        this.selectStandard.splice(index, 1)
      } else {
        if (this.selectStandard.length >= 3) return
        this.selectStandard.push(it)
      }
    }
  }
}
</script>

<style lang="stylus">
  .employ-wrap
    margin-top 9px
    .select-post, .want-place, .select-standard-wrap
      .title
        width 300px
        height 30px
        font-weight bold
        line-height 30px
        font-size 14px
        display inline-block
        vertical-align middle
      .content
        display inline-block
        padding-left 15px
        width calc(100% - 330px)
        height 30px
        font-size 14px
        color #666
        line-height 30px
        border-bottom 1px solid #ddd
        vertical-align middle
    .upload-wrap
      position relative
      margin-top 48px
      .upload-tip
        position absolute
        top 7px
        left 129px
      p
        margin 0
        padding 0
        color #666
        font-size 12px
      .upload-btn
        width 106px
        height 48px
        background-color #007ab0
        border-radius 2px
        font-size 12px
      .upload-file
        position absolute
        top 0
        left 0
        width 100%
        height 48px
        opacity 0
    .file-list
      margin-top 15px
      .text
        font-size 13px
        color #999
    .check-wrap
      margin-top 48px
    .select-standard-box
      display flex
      margin-top 24px
      width 100%
      .standard-item
        cursor pointer
        padding 0 10px
        margin-right 16px
        height 24px
        line-height 24px
        text-align center
        font-size 12px
        color #666
        background-color #eee
        &.active
          background-color #007ab0
          color #fff
    .select-standard-wrap
      margin-top 32px
      .title
        font-weight bold
        width 543px
      .content
        width calc(100% - 565px)
    .want-place
      .title
        width 250px
    .assign-wrap
      margin-top 33px
      margin-bottom 33px
      .title
        margin-bottom 12px
        font-size 14px
        font-weight bold
    .want-place-box
      margin-top 24px
    .month-income-wrap
      .title
        margin-bottom 24px
        font-size 14px
        font-weight bold
      .content
        .arrival-picker
          margin-left 32px
    .select-box-wrap
      .title
        margin-top 24px
        font-size 14px
        font-weight bold
        .sub-title
          font-size 12px
          font-weight normal
      .content
        .primary-wrap, .middle-wrap, .high-wrap
          .desc
            display inline-block
            margin-right 24px
            margin-top 24px
            width 56px
            height 24px
            line-height 24px
            font-size 12px
            color #007ab0
            border-radius 2px
            background-color #eaf9ff
            text-align center
          .el-checkbox-group
            display inline-block
    .coach-wrap, manage-train-wrap
      margin 24px 0
      .title
        margin-bottom 0px
        font-size 14px
        font-weight bold
        color #333
.checkdiv
    margin-top 10px
</style>



// WEBPACK FOOTER //
// src/components/employ/employ.vue